import {
  CreateOrganizationRequest,
  InviteOrganizationMemberRequest,
  Organization,
  OrganizationInvitation,
  OrganizationMember,
  PublicOrganization,
  UpdateOrganizationRequest,
} from "@facade/contracts";

import { api } from "@facade/api";

export const organizationsApi = {
  async get() {
    const { data } = await api.get<Organization[]>("/organizations");
    return data;
  },
  async getPublic() {
    const { data } = await api.get<PublicOrganization[]>(
      "/organizations/public",
    );
    return data;
  },
  async getById(organizationId: string) {
    const { data } = await api.get<Organization>(
      `/organizations/${organizationId}`,
    );
    return data;
  },
  async getPublicById(organizationId: string) {
    const { data } = await api.get<PublicOrganization>(
      `/organizations/${organizationId}/public`,
    );
    return data;
  },
  async create(organization: CreateOrganizationRequest) {
    const { data } = await api.post<Organization>(
      "/organizations",
      organization,
    );
    return data;
  },
  async update(organization: UpdateOrganizationRequest) {
    const { data } = await api.put<Organization>(
      `/organizations/${organization.id}`,
      organization,
    );
    return data;
  },
  async delete(organizationId: string) {
    await api.delete(`/organizations/${organizationId}`);
  },
  async getMembers(organizationId: string) {
    const { data } = await api.get<OrganizationMember[]>(
      `/organizations/${organizationId}/members`,
    );
    return data;
  },
  async getInvitations() {
    const { data } = await api.get<OrganizationInvitation[]>(
      "/organization-invitations",
    );
    return data;
  },
  async inviteMember(
    organizationId: string,
    invitation: InviteOrganizationMemberRequest,
  ) {
    const { data } = await api.post<OrganizationMember>(
      `/organizations/${organizationId}/members/invitations`,
      invitation,
    );
    return data;
  },
  async acceptInvitation(organizationId: string) {
    const { data } = await api.post<OrganizationMember>(
      `/organizations/${organizationId}/members/me/accept`,
    );
    return data;
  },
  async declineInvitation(organizationId: string) {
    const { data } = await api.post<OrganizationMember>(
      `/organizations/${organizationId}/members/me/decline`,
    );

    return data;
  },
};
